/* eslint-disable max-len */
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import ComponentPageHeader from '../../Common/PageHeader/ComponentPageHeader';
import './Dashboard.scss';
import DashboardChart from './DashboardChart';
import { RootState } from '../../redux/rootState';
import {
  clearMorningReportPdf, getDashboardData, getMorningReport, resetDashboardState,
} from './redux/dashboardSlice';
import { setLoader } from '../../redux/loaderSlice';
import bannerImage from '../../assets/BannerImage.svg';
import userIcon from '../../assets/Icons/userIconImage.svg';
import morningReportIcon from '../../assets/morningReport.svg';
import jobIcon from '../../assets/jobIcon.svg';
import tubesIcon from '../../assets/tubesIcon.svg';
import syncIcon from '../../assets/sync.svg';
import bidReportIcon from '../../assets/bidReport.svg';
import printerIconBlack from '../../assets/printerIconBlack.svg';
import MorningReportModal from './MorningReportModal';
import MorningReportPdf from './MorningReportPdf/MorningReportPdf';
import { showErrorToaster } from '../../Common/ComponentToast/ComponentSuccessToasts';
import AnalystTubeCountModal from './AnalystTubeCountModal';
import { ADMIN_ROLE_ID, FRONT_OFFICE_ID } from '../../Routes/constant';
import localStorageConstants from '../../utils/LocalStorageConstants';
import SyncDownReportModal from './SyncDownReportModal';
import EndPoints from '../../Routes/EndPoints';
import BidReportModal from './BidReportModal';
import JobBidReportModal from './JobBidReportModal';
import { getJobBidReportFailure } from '../JobScheduling/UnscheduledJobs/addJob/redux/jobScheduleSlice';

function DashBoard() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const printRef = useRef(null);
  const [oilKitOrder, setOilKitOrder] = useState<number>(0);
  const [freonOrder, setFreonOrder] = useState<number>(0);
  const [showMorningRepModal, setShowMorningRepModal] = useState<boolean>(false);
  const [showAnalystModal, setShowAnalystModal] = useState<boolean>(false);
  const [showSyncDownRepModal, setShowSyncDownRepModal] = useState<boolean>(false);
  const [showBidReportModal, setShowBidReportModal] = useState<boolean>(false);
  const [showJobBidReportModal, setShowJobBidReportModal] = useState<boolean>(false);

  const {
    isLoading, type, fromDate, toDate, dashboardData, isMorningRepLoading, morningReportData,
  } = useSelector((state: RootState) => state.dashboardReducer);
  const roleId = localStorage.getItem(localStorageConstants.ROLE_ID);

  useEffect(() => {
    const reqBody = {
      fromDate,
      toDate,
      type,
    };
    dispatch(getDashboardData(reqBody));
    return () => {
      dispatch(resetDashboardState());
    };
  }, [type, fromDate, toDate]);

  useEffect(() => {
    dispatch(getMorningReport());
  }, []);

  useEffect(() => {
    if (isLoading || isMorningRepLoading) {
      dispatch(setLoader(true));
    } else {
      dispatch(setLoader(false));
    }
  }, [isLoading, isMorningRepLoading]);

  useEffect(() => {
    if (dashboardData?.OilKitsOrderCounts) {
      setOilKitOrder(dashboardData?.OilKitsOrderCounts);
    }
    if (dashboardData?.FreonOrderCounts) {
      setFreonOrder(dashboardData?.FreonOrderCounts);
    }
  }, [dashboardData]);

  const handlePrint = useReactToPrint({
    content: () => printRef?.current,
    removeAfterPrint: true,
    copyStyles: true,
    documentTitle: 'Morning_Report',
  });

  const handlePrintPdf = () => {
    if (morningReportData?.RecordsForDue?.length > 0 || morningReportData?.RecordsForMorningReport?.length > 0) {
      handlePrint();
    } else {
      showErrorToaster('Currently, there are no received or overdue reports available.');
    }
  };
  const handleCustomerClick = () => {
    if (roleId === String(ADMIN_ROLE_ID) || roleId === FRONT_OFFICE_ID) {
      navigate(`/${EndPoints.Customers}`);
    }
  };
  const handleJobClick = () => {
    if (roleId === String(ADMIN_ROLE_ID) || roleId === FRONT_OFFICE_ID) {
      navigate(`/${EndPoints.JOBS}`);
    }
  };

  return (
    <>
      <ComponentPageHeader subHeading="Dashboard" />
      <div className="dashboardCardWrapper div_job_container_info">
        <Grid container spacing={2}>
          <Grid item md={7} sm={12} xs={12}>
            <Grid container spacing={4}>
              <Grid item md={12} sm={12} xs={12}>
                <div className="dashboardBanner"><img src={bannerImage} alt="Banner" /></div>
              </Grid>
              {roleId === String(ADMIN_ROLE_ID) && (
              <Grid item md={6} sm={12} xs={12}>
                <div className="dashboardCardContainer pointCursor" onClick={() => { setShowMorningRepModal(true); }}>
                  <div className="dashboardCardIcon green">
                    <img src={morningReportIcon} alt="icon" height={40} width={40} />
                  </div>
                  <div className="dashboardCardContent">
                    <div className="dashboardCardText">Morning Report</div>
                    <div className="dashboardCardValue" onClick={(e) => { e.stopPropagation(); handlePrintPdf(); }}>
                      <img src={printerIconBlack} alt="download" title="Preview" height={30} width={30} />
                    </div>
                  </div>
                </div>
              </Grid>
              )}
              {roleId === String(ADMIN_ROLE_ID) && (
              <Grid item md={6} sm={12} xs={12}>
                <div style={{ minHeight: '117px' }} className="dashboardCardContainer pointCursor" onClick={() => { setShowAnalystModal(true); }}>
                  <div className="dashboardCardIcon blue">
                    <img src={tubesIcon} alt="icon" height={40} width={40} />
                  </div>
                  <div className="dashboardCardContent">
                    <div className="dashboardCardText">Analyst Tube Count</div>
                  </div>
                </div>
              </Grid>
              )}
              {(roleId === String(ADMIN_ROLE_ID) || roleId === FRONT_OFFICE_ID) && (
              <Grid item md={6} sm={12} xs={12}>
                <div style={{ minHeight: '117px' }} className="dashboardCardContainer pointCursor" onClick={() => { setShowSyncDownRepModal(true); }}>
                  <div className="dashboardCardIcon pink">
                    <img src={syncIcon} alt="icon" height={40} width={40} />
                  </div>
                  <div className="dashboardCardContent">
                    <div className="dashboardCardText">Job Sync Pending Report</div>
                  </div>
                </div>
              </Grid>
              )}
              {(roleId === String(ADMIN_ROLE_ID) || roleId === FRONT_OFFICE_ID) && (
              <Grid item md={6} sm={12} xs={12}>
                <div style={{ minHeight: '117px' }} className="dashboardCardContainer pointCursor" onClick={() => { setShowBidReportModal(true); }}>
                  <div className="dashboardCardIcon red">
                    <img src={bidReportIcon} alt="icon" height={42} width={42} />
                  </div>
                  <div className="dashboardCardContent">
                    <div className="dashboardCardText">Bid Report</div>
                  </div>
                </div>
              </Grid>
              )}
              {(roleId === String(ADMIN_ROLE_ID)) && (
              <Grid item md={6} sm={12} xs={12}>
                <div style={{ minHeight: '117px' }} className="dashboardCardContainer pointCursor" onClick={() => { setShowJobBidReportModal(true); }}>
                  <div className="dashboardCardIcon indigo">
                    <img src={bidReportIcon} alt="icon" height={42} width={42} />
                  </div>
                  <div className="dashboardCardContent">
                    <div className="dashboardCardText">Job/Bid Report</div>
                  </div>
                </div>
              </Grid>
              )}
              <Grid item md={6} sm={12} xs={12}>
                <div className="dashboardCardContainer pointCursor" onClick={handleCustomerClick}>
                  <div className="dashboardCardIcon purple">
                    <img src={userIcon} alt="icon" />
                  </div>
                  <div className="dashboardCardContent">
                    <div className="dashboardCardText">Number of Customers</div>
                    <div className="dashboardCardValue">{dashboardData.CustomerCounts}</div>
                  </div>
                </div>
              </Grid>
              <Grid item md={6} sm={12} xs={12}>
                <div className="dashboardCardContainer pointCursor" onClick={handleJobClick}>
                  <div className="dashboardCardIcon orange">
                    <img src={jobIcon} alt="icon" height={38} width={38} />
                  </div>
                  <div className="dashboardCardContent">
                    <div className="dashboardCardText">Number of Jobs</div>
                    <div className="dashboardCardValue">{dashboardData.JobCounts}</div>
                  </div>
                </div>
              </Grid>
            </Grid>
          </Grid>
          <Grid item md={5} sm={12} xs={12}>
            <DashboardChart oilKitOrders={oilKitOrder} freonOrders={freonOrder} />
          </Grid>
        </Grid>
      </div>
      <div className="footer">
        Copyright © 2023 &nbsp;
        <Link to="http://taiservices.com/" target="_blank">Taiservices</Link>
        . Designed by&nbsp;
        <Link to="https://binmile.com/" target="_blank">Binmile Technologies Private Limited</Link>
        .&nbsp;All rights reserved.
      </div>
      <MorningReportModal
        open={showMorningRepModal}
        handleClose={() => { setShowMorningRepModal(false); dispatch(clearMorningReportPdf()); }}
        handlePrinting={handlePrintPdf}
      />
      {showSyncDownRepModal && (
      <SyncDownReportModal
        open={showSyncDownRepModal}
        handleClose={() => setShowSyncDownRepModal(false)}
        // handlePrinting={handlePrintPdf}
      />
      )}
      {showBidReportModal && (
      <BidReportModal
        open={showBidReportModal}
        handleClose={() => setShowBidReportModal(false)}
      />
      )}
      {showJobBidReportModal && (
      <JobBidReportModal
        open={showJobBidReportModal}
        handleClose={() => { setShowJobBidReportModal(false); dispatch(getJobBidReportFailure()); }}
      />
      )}
      {showAnalystModal && (
      <AnalystTubeCountModal
        open={showAnalystModal}
        handleClose={() => setShowAnalystModal(false)}
      />
      )}
      <MorningReportPdf printRef={printRef} />
    </>
  );
}

export default DashBoard;
